




// 自訂 : 國定假日 / 熱門時段 ( 原價 )
export const national_Holidays : NationalHoliday[] = [

   { title : '熱門' , date : '2023-08-31' }
  

] ;



/*

  各種房型，於不同時段( 平日、假日、國定假日 ) : 價格 ( 2023.08.09 )

*/ 

// 方案 1 : 不退款 ( 不換寵物優惠 )
export const lodge_PricePlan_1 : RoomType_Prices[] = [

   // 淡水狗
   { roomType : '淡_大房' , ordinary_Price : 1200 , holiday_Price : 1080 , regularDay_Price: 960 } ,
   { roomType : '淡_中房' , ordinary_Price : 1000 , holiday_Price : 900  , regularDay_Price: 800 } ,
   { roomType : '淡_大籠' , ordinary_Price : 700  , holiday_Price : 630  , regularDay_Price: 560 } ,
   { roomType : '淡_中籠' , ordinary_Price : 600  , holiday_Price : 540  , regularDay_Price: 480 } ,
   { roomType : '淡_小籠' , ordinary_Price : 500  , holiday_Price : 450  , regularDay_Price: 400 } ,

   // 淡水貓
   { roomType : '淡_豪華樓中樓' , ordinary_Price : 1200 , holiday_Price : 1080 , regularDay_Price: 960 } ,
   { roomType : '淡_溫馨房'    , ordinary_Price : 600 , holiday_Price : 540 , regularDay_Price: 480 } ,
   { roomType : '淡_挑高房'    , ordinary_Price : 700 , holiday_Price : 630 , regularDay_Price: 560 } ,

   // 紅樹林
   { roomType : '紅_景觀中房' , ordinary_Price : 1200 , holiday_Price : 1080 , regularDay_Price: 960 } ,
   { roomType : '紅_海島中房' , ordinary_Price : 1200 , holiday_Price : 1080 , regularDay_Price: 960 } ,
   { roomType : '紅_北歐中房' , ordinary_Price : 1200 , holiday_Price : 1080 , regularDay_Price: 960 } ,
   { roomType : '紅_大運動場' , ordinary_Price : 1200 , holiday_Price : 1080 , regularDay_Price: 960 } ,
   { roomType : '紅_運動場休息區' , ordinary_Price : 1200 , holiday_Price : 1080 , regularDay_Price: 960 } ,
   //{ roomType : '運動場1休息區' , ordinary_Price : 1200 , holiday_Price : 1080 , regularDay_Price: 960 } ,
   //{ roomType : '運動場2休息區' , ordinary_Price : 1200 , holiday_Price : 1080 , regularDay_Price: 960 } ,
   //{ roomType : '運動場3休息區' , ordinary_Price : 1200 , holiday_Price : 1080 , regularDay_Price: 960 } ,
   { roomType : '紅_住宿走道' , ordinary_Price : 1200 , holiday_Price : 1080 , regularDay_Price: 960 } ,
] ;


// 方案 2 : 退款 ( 退訂可換住宿券 )
export const lodge_PricePlan_2 : RoomType_Prices[] = [

   // 淡水狗 
   { roomType : '淡_大房' , ordinary_Price : 1400 , holiday_Price : 1260 , regularDay_Price: 1120 } ,
   { roomType : '淡_中房' , ordinary_Price : 1200 , holiday_Price : 1080 , regularDay_Price: 960 } ,
   { roomType : '淡_大籠' , ordinary_Price : 900  , holiday_Price : 810  , regularDay_Price: 720 } ,
   { roomType : '淡_中籠' , ordinary_Price : 800  , holiday_Price : 720  , regularDay_Price: 640 } ,
   { roomType : '淡_小籠' , ordinary_Price : 700  , holiday_Price : 630  , regularDay_Price: 560 } ,

   // 淡水貓
   { roomType : '淡_豪華樓中樓' , ordinary_Price : 1400 , holiday_Price : 1260 , regularDay_Price: 1120 } ,
   { roomType : '淡_溫馨房'    , ordinary_Price : 800  , holiday_Price : 720  , regularDay_Price: 640 } ,
   { roomType : '淡_挑高房'    , ordinary_Price : 900  , holiday_Price : 810  , regularDay_Price: 720 } ,


   // 紅樹林狗
   { roomType : '紅_景觀中房' , ordinary_Price : 1400 , holiday_Price : 1260 , regularDay_Price: 1120 } ,
   { roomType : '紅_海島中房' , ordinary_Price : 1400 , holiday_Price : 1260 , regularDay_Price: 1120 } ,
   { roomType : '紅_北歐中房' , ordinary_Price : 1400 , holiday_Price : 1260 , regularDay_Price: 1120 } ,
   { roomType : '紅_大運動場' , ordinary_Price : 1400 , holiday_Price : 1260 , regularDay_Price: 1120 } ,
   { roomType : '紅_運動場休息區' , ordinary_Price : 1400 , holiday_Price : 1260 , regularDay_Price: 1120 } ,
   //{ roomType : '運動場1休息區' , ordinary_Price : 1400 , holiday_Price : 1260 , regularDay_Price: 1120 } ,
   //{ roomType : '運動場2休息區' , ordinary_Price : 1400 , holiday_Price : 1260 , regularDay_Price: 1120 } ,
   //{ roomType : '運動場3休息區' , ordinary_Price : 1400 , holiday_Price : 1260 , regularDay_Price: 1120 } ,
   { roomType : '紅_住宿走道' , ordinary_Price : 1400 , holiday_Price : 1260 , regularDay_Price: 1120 } ,	
] ;



// 房間 ( 房型 / 房號 )
export const lodge_Rooms : Room_Type_Number[] = [
    //淡水狗
    { type : '淡_大房' , number : [ 'A01' , 'A02' , 'A03' , 'A05' , 'A06' ] } ,
    { type : '淡_中房' , number : [ 'B01' , 'B02' , 'B03' , 'B05' , 'B06' , 'B07' , 'B08' , 'B09' , 'B10' , 'B11' ] } ,
    //淡水狗 
    { type : '淡_大籠' , number : [ 'G01' , 'G02' , 'G03' , 'G04' , 'G05' ] } ,
    { type : '淡_中籠' , number : [ 'H01' , 'H02' , 'H03' , 'H04' , 'H05' , 'H06' , 'H07' , 'H08' , 'H09' ] } ,
    { type : '淡_小籠' , number : [ 'I01' , 'I02' , 'I03' , 'I04' , 'I05' , 'I06' , 'I07' , 'I08' , 'I09' , 'I10' ] } ,
    //淡水貓
    { type : '淡_豪華樓中樓' , number : [ 'C113' , 'C123' , 'C133' , 'C213' , 'C223' , 'C233' , 'C313' , 'C323' , 'C333' ] } ,
    //淡水貓
    { type : '淡_溫馨房' , number : [
                                  // 上 
                                  'C111' , 'C121' , 'C131' , 'C211' , 'C221' , 'C231' , 'C311' , 'C321' , 'C331' ,
                                  // 下
                                  'C112' , 'C122' , 'C132' , 'C212' , 'C222' , 'C232' , 'C312' , 'C322' , 'C332'
                                ]} ,
    //淡水貓
    { type : '淡_挑高房' , number : [ 'E151' , 'E161' , 'E171' ] } ,
	
	//紅樹林
	{ type : '紅_景觀中房' , number : [ 'R101' , 'R102' , 'R103' ] } ,
	{ type : '紅_海島中房' , number : [ 'R201' , 'R202' , 'R203', 'R205' ] } ,
	{ type : '紅_北歐中房' , number : [ 'R301' , 'R302' , 'R303', 'R305' ] } ,
	{ type : '紅_大運動場' , number : [ 'R501' ] } ,
	{ type : '紅_運動場休息區' , number : [ 'R502' , 'R503' , 'R505' ] } ,
	//{ type : '運動場1休息區' , number : [ 'R502' ] } ,
	//{ type : '運動場2休息區' , number : [ 'R503' ] } ,
	//{ type : '運動場3休息區' , number : [ 'R505' ] } ,
	{ type : '紅_住宿走道' , number : [ 'R506' ] } ,	

  ] ;

